import { currentAccountSelector } from "./currentAccountSelector";
import { RootState } from "../../../store";

export const isCurrentAccountSubAccountSelector = (state: RootState) => {
  const account = currentAccountSelector(state);

  return account?.is_sub_account;
};
